import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Portafoglio } from 'src/app/models/portafoglio';
import { PortafoglioPostData } from 'src/app/models/portafoglioPostData';
import { PortafoglioRecord } from 'src/app/models/portafoglioRecord';
import { ConstantsStore } from '../constants.store';
import { CACHE_KEY } from '../interceptors/cache-header.interceptor';
import {PortfolioWithSummary} from '../../../models/Portfolio/PortfolioWithSummary';
import { RenameModel } from 'src/app/models/renameModel';
import {
  SellCertificateRequest
} from '../../../features/portfolios/vendita-portfolio-isin-dialog/vendita-portfolio-isin-dialog.component';
import {tap} from 'rxjs/operators';
import {UpdateCertificateNotVisibleRequest} from '../../../models/Portfolio/update-certificate-not-visible.request';
import {PortfolioByIsinDetail} from '../../../models/Portfolio/portfolio-by-isin-detail';

@Injectable({
  providedIn: 'root'
})
export class PortfoliosService {

  userPortfolios: Portafoglio[];

  constructor(
    private constants: ConstantsStore,
    private http: HttpClient
  ) { }

  getUserPortfolios(): Observable<Portafoglio[]> {
    return this.httpGet().pipe(
      tap((portfolios: Portafoglio[]) => {
        this.userPortfolios = [...portfolios];
      })
    );
  }

  addPortfolio(portfolioName: string) {
    return new Observable(observer => {
      this.httpPost(portfolioName)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }

  updatePortfolioStatus(portfolioId: number) {
    return new Observable(observer => {
      this.httpPut(portfolioId)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }

  updatePortfolioName(portfolio: RenameModel) {
    return this.httpPatchNamePortfolio(portfolio);
  }

  deletePortfolio(portfolioId: number) {
    return new Observable(observer => {
      this.httpDelete(portfolioId)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }

  private httpGet() {
    const getHeaders = { [CACHE_KEY]: '1' };
    return this.http.get<Portafoglio[]>(this.constants.portafoglioManagementUrl, { headers: getHeaders });
  }
  private httpPost = (portfolioName: string) => this.http.post(`${this.constants.portafoglioManagementUrl}/${portfolioName}`, {});
  private httpPut = (portfolioId: number) => this.http.put(`${this.constants.portafoglioManagementUrl}/${portfolioId}`, {});
  private httpDelete = (portfolioId: number) => this.http.delete(`${this.constants.portafoglioManagementUrl}/${portfolioId}`);
  private httpPatchNamePortfolio = (portfolio: RenameModel) => this.http.patch(`${this.constants.portafoglioManagementUrl}`, portfolio);



  getPortfolioContent(portfolioId: number) {
    const getHeaders = { [CACHE_KEY]: '1' };
    return this.http.get<PortfolioWithSummary>(`${this.constants.portafoglioUrl}/${portfolioId}`, { headers: getHeaders });
  }

  addCertificate(certificate: PortafoglioPostData) {
    return new Observable(observer => {
      this.httpPostContent(certificate)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }

  updateCertificate(certificate: PortafoglioRecord) {
    return new Observable(observer => {
      this.httpUpdateContent(certificate)
      .subscribe(
        () => observer.next(),
        error => observer.error(error)
      );
    });
  }

  deleteCertificate(id: number) {
      return this.httpDeleteContent(id);
  }


  private httpPostContent = (certificate: PortafoglioPostData) => this.http.post(`${this.constants.portafoglioUrl}`, certificate);
  private httpUpdateContent = (certificate: PortafoglioRecord) => this.http.patch(`${this.constants.portafoglioUrl}`, certificate);
  private httpDeleteContent = (id: number) => this.http.delete(`${this.constants.portafoglioUrl}/${id}`);

  downloadUserPortfoliosExcel(userId: string): Promise<Blob> {
    return this.http.get(`${this.constants.portafoglioManagementUrl}/download/${userId}`, {responseType: 'blob'}).toPromise();
  }

  sellCertificate = (sellCertificateRequest: SellCertificateRequest, portfolioId: number) => {
    return this.http.post<void>(`${this.constants.portafoglioUrl}/${portfolioId}/certificati-venduti`, sellCertificateRequest).toPromise();
  }

  hasCertificates(portfolioId: number) {
    return this.http.get<boolean>(`${this.constants.portafoglioUrl}/${portfolioId}/certificates/exist`);
  }

  updateRimborsatoScaduto(portfolioId: number, certificateId: number, request: UpdateCertificateNotVisibleRequest) {
    return this.http.put(
      `${this.constants.portafoglioUrl}/${portfolioId}/RimborsatiScaduti/${certificateId}`,
      request,
      {observe: 'response'});
  }

  updateVenduto(portfolioId: number, certificateId: number, request: UpdateCertificateNotVisibleRequest) {
    return this.http.put(
      `${this.constants.portafoglioUrl}/${portfolioId}/certificati-venduti/${certificateId}`,
      request,
      {observe: 'response'});
  }

  getPortfoliosByIsinDetails(isin: string, acquistato?: boolean): Observable<PortfolioByIsinDetail[]> {
    let params = new HttpParams();
    if (acquistato) { params = params.set('acquistato', acquistato.toString()); }
    return this.http.get<PortfolioByIsinDetail[]>(`${this.constants.portafoglioManagementUrl}/isin/${isin}/details`, { params });
  }
}
